/*global VeloxGridAndFormController*/


var renewNotifController = new VeloxGridAndFormController("renew_notif", {
    grid : {
        directory: "views/reseller",
        name: "renewNotifGrid",
    },
    form : {
        directory: "views/reseller",
        name: "renewNotifForm",
        defaultData : {
            rn_lang: "fr-FR"
        }
    }
});

module.exports = renewNotifController ;